/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import React, { useState, useEffect } from "react";
import { usePluginProvider } from "../../../../providers";
import { Link as RouterLink, useLocation, NavLink } from "react-router-dom";
import { User } from '@cloudpremise/portal_core';

// @mui material components
import Divider from "@mui/material/Divider";
import Switch from "@mui/material/Switch";
import IconButton from "@mui/material/IconButton";
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";
import { Theme } from "@mui/material/styles";
import EmojiEmotionsOutlinedIcon from '@mui/icons-material/EmojiEmotionsOutlined';
import PersonOutlinedIcon from '@mui/icons-material/PersonOutlined';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined';


// Material Dashboard 2 PRO React TS components
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import MDButton from "../../components/MDButton";
import List from "@mui/material/List";

// Custom styles for the Configurator
import UsernavRoot from "./UsernavRoot";
import SidenavCollapse from "../Sidenav/SidenavCollapse";
import SidenavList from "../Sidenav/SidenavList";
import SidenavItem from "../Sidenav/SidenavItem";

// Material Dashboard 2 PRO React context
import {
  useMaterialUIController,
} from "../../context";

function Usernav(props): JSX.Element {
  const { open, onClose, userImage } = props;
  const [controller, dispatch] = useMaterialUIController();
  const {
    user,
    darkMode,
  } = controller;

  return (
    <UsernavRoot variant="permanent" ownerState={{ open, darkMode }}>
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        pt={2}
        pb={0.5}
        px={2}
      >
        <MDBox component={NavLink} to="/" display="flex" alignItems="center">
          <MDBox component="img" src={userImage} alt="User" width="2rem" mr={2} />
          <MDBox>
            <MDTypography component="h6" variant="button" fontWeight="medium" color={"dark"}>
              {user.getTitle()}
            </MDTypography>
          </MDBox>
        </MDBox>
        <MDBox display="flex" alignItems="center">
          <IconButton
              size="medium"
          >
            <Icon
              sx={({ typography: { size }, palette: { dark, white } }) => ({
                fontSize: `${size.xl} !important`,
                color: darkMode ? white.main : dark.main,
                stroke: "currentColor",
                strokeWidth: "2px",
                cursor: "pointer",
              })}
            >
              multiple_stop_outlined
            </Icon>
          </IconButton>
          <IconButton
              size="medium"
          >
            <Icon
              sx={({ typography: { size }, palette: { dark, white } }) => ({
                fontSize: `${size.lg} !important`,
                color: darkMode ? white.main : dark.main,
                stroke: "currentColor",
                strokeWidth: "2px",
                cursor: "pointer",
              })}
              onClick={onClose}
            >
              close
            </Icon>
          </IconButton>
        </MDBox>
      </MDBox>
      <List>
        <NavLink to={"/set-status"+window.location.search} style={{ textDecoration: "none" }} >
          <SidenavItem color={"dark"} icon={<EmojiEmotionsOutlinedIcon />} name={"Set Status"} />
        </NavLink>
      </List>
      <Divider />
      <List>
        <NavLink to={"/profile"+window.location.search} style={{ textDecoration: "none" }} >
          <SidenavItem color={"dark"} icon={<PersonOutlinedIcon />} name={"Your Profile"} />
        </NavLink>
        <NavLink to={"/bpm/queues/availablequeues"+window.location.search} style={{ textDecoration: "none" }} >
          <SidenavItem color={"dark"} icon={<AssignmentTurnedInOutlinedIcon />} name={"Your Tasks"} />
        </NavLink>
      </List>
      <Divider />
      <List>
        <NavLink to={"/settings"+window.location.search} style={{ textDecoration: "none" }} >
          <SidenavItem color={"dark"} icon={<SettingsOutlinedIcon />} name={"Settings"} />
        </NavLink>
      </List>
      <Divider />
      <List>
        <Link href={"https://olympus-grid.com/"} target="_blank" style={{ textDecoration: "none" }} >
          <SidenavItem color={"dark"} icon={<LanguageOutlinedIcon />} name={"Olympus-Grid Website"} />
        </Link>
        <Link href={"https://docs.olympus-grid.net/"} target="_blank" style={{ textDecoration: "none" }} >
          <SidenavItem color={"dark"} icon={<ArticleOutlinedIcon />} name={"Olympus-Grid Documentation"} />
        </Link>
        <Link href={"https://support.olympus-grid.com/"} target="_blank" style={{ textDecoration: "none" }} >
          <SidenavItem color={"dark"} icon={<HelpOutlineOutlinedIcon />} name={"Olympus-Grid Support"} />
        </Link>
        <Link href={"https://olympus-grid.com/"} target="_blank" style={{ textDecoration: "none" }} >
          <SidenavItem color={"dark"} icon={<PeopleAltOutlinedIcon />} name={"Olympus-Grid Community"} />
        </Link>
      </List>
      <Divider />
      <List>
        <NavLink to={"/auth/logout"+window.location.search} style={{ textDecoration: "none" }} >
          <SidenavItem color={"dark"} icon={<LogoutOutlinedIcon />} name={"Sign Out"} />
        </NavLink>
      </List>
    </UsernavRoot>
  );
}
  
export default Usernav;
